import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-dutyfree-option-picker',
  templateUrl: './dutyfree-option-picker.component.html',
  styleUrls: ['./dutyfree-option-picker.component.scss'],
})
export class DutyfreeOptionPickerComponent implements OnInit {
  @Input() title = 'Select';
  @Input() options: string[] = [];
  @Input() selected = '';

  public searchQuery = '';
  public choices: string[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.choices = (this.options || []).map((option) => String(option ?? ''));
  }

  get showSearch(): boolean {
    return this.choices.length > 6;
  }

  get filteredOptions(): string[] {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) {
      return this.choices;
    }
    return this.choices.filter((option) => option.toLowerCase().includes(query));
  }

  clearSearch() {
    this.searchQuery = '';
  }

  close() {
    this.modalController.dismiss();
  }

  selectOption(option: string) {
    this.modalController.dismiss(option);
  }
}
